import { createSelector } from '@ngrx/store';
import { getAuthenticatedUser } from '../auth.selectors';
import { AuthenticatedUserStateInterface } from './authenticated-user.state';

export const getCurrentUserInfo = createSelector(
  getAuthenticatedUser,
  (state: AuthenticatedUserStateInterface) => state.user
);
